import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
    if (this.props.onRetry) this.props.onRetry();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={styles.container} role="alert" aria-live="assertive">
          <div style={styles.card}>
            <span style={styles.icon} aria-hidden="true">⚠️</span>
            <h2 style={styles.title}>Something went wrong</h2>
            <p style={styles.desc}>
              We encountered an unexpected error. Please try again.
            </p>
            <button style={styles.btn} onClick={this.handleRetry}>
              Try Again
            </button>
            <a href="/" style={styles.link}>Go to Homepage</a>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

const styles = {
  container: {
    minHeight: "60vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "2rem",
    background: "#fafafa",
  },
  card: {
    background: "#fff",
    borderRadius: "16px",
    padding: "3rem 2.5rem",
    textAlign: "center",
    boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
    maxWidth: "400px",
    width: "100%",
  },
  icon: { fontSize: "3rem", display: "block", marginBottom: "1rem" },
  title: { fontSize: "1.4rem", fontWeight: 700, color: "#1a1a1a", margin: "0 0 0.5rem" },
  desc: { color: "#666", fontSize: "0.95rem", marginBottom: "1.5rem" },
  btn: {
    display: "inline-block",
    background: "#e96c4c",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    padding: "10px 24px",
    fontSize: "0.9rem",
    fontWeight: 600,
    cursor: "pointer",
    marginBottom: "1rem",
  },
  link: {
    display: "block",
    color: "#e96c4c",
    fontSize: "0.85rem",
    textDecoration: "underline",
    cursor: "pointer",
  },
};

export default ErrorBoundary;
